import { BaseCredentialApplicationReportFields } from 'src/app/shared/components/credential-application-report/base-credential-application-report.fields';
import { ItemPickerModel } from 'src/app/shared/components/item-picker/models/itemPickerModel';

export const InProgressEntityCredentialApplicationFields = {
  ...BaseCredentialApplicationReportFields,
  entityId: 'entityId',
  entityType: 'entityType',
  entityCredentialId: 'entityCredentialId',
  name: 'name',
  email: 'email',
  workspaceId: 'workspaceId',
  workspaceName: 'workspaceName',
  scenario: 'scenario',
  paymentStatus: 'paymentStatus',
  paymentMethod: 'paymentMethod',
  paymentCompletionDate: 'paymentCompletionDate',
  invoiceNumber: 'invoiceNumber'
} as const;

export type InProgressEntityCredentialApplicationFields =
  (typeof InProgressEntityCredentialApplicationFields)[keyof typeof InProgressEntityCredentialApplicationFields];

export const InProgressEntityCredentialApplicationSystemColumns: ItemPickerModel[] = [
  new ItemPickerModel(
    InProgressEntityCredentialApplicationFields.credentialApplicationNumber,
    '',
    'Application Number'
  ),
  new ItemPickerModel(InProgressEntityCredentialApplicationFields.name, '', 'Name'),
  new ItemPickerModel(
    InProgressEntityCredentialApplicationFields.entityType,
    '',
    'Credential Type'
  ),
  new ItemPickerModel(
    InProgressEntityCredentialApplicationFields.credentialName,
    '',
    'Credential Name'
  ),
  new ItemPickerModel(
    InProgressEntityCredentialApplicationFields.applicationStatusLabel,
    '',
    'Application Status'
  ),
  new ItemPickerModel(
    InProgressEntityCredentialApplicationFields.credentialApplicationType,
    '',
    'Application Type'
  ),
  new ItemPickerModel(
    InProgressEntityCredentialApplicationFields.credentialApplicationStartDate,
    '',
    'Application Start'
  ),
  new ItemPickerModel(
    InProgressEntityCredentialApplicationFields.credentialApplicationEndDate,
    '',
    'Application End'
  ),
  new ItemPickerModel(
    InProgressEntityCredentialApplicationFields.credentialApplicationUpdatedOn,
    '',
    'Last Updated'
  ),
  new ItemPickerModel(
    InProgressEntityCredentialApplicationFields.workspaceName,
    '',
    'Workspace Name'
  ),
  new ItemPickerModel(InProgressEntityCredentialApplicationFields.scenario, '', 'Scenario'),
  new ItemPickerModel(
    InProgressEntityCredentialApplicationFields.paymentMethod,
    '',
    'Payment Method'
  ),
  new ItemPickerModel(
    InProgressEntityCredentialApplicationFields.paymentCompletionDate,
    '',
    'Payment Completion Date'
  ),
  new ItemPickerModel(
    InProgressEntityCredentialApplicationFields.paymentStatus,
    '',
    'Payment Status'
  ),
  new ItemPickerModel(
    InProgressEntityCredentialApplicationFields.invoiceNumber,
    '',
    'Invoice Number'
  )
];
